/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDictionaryTypeDto
 */
export interface GetDictionaryTypeDto {
    /**
     * 
     * @type {string}
     * @memberof GetDictionaryTypeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetDictionaryTypeDto
     */
    name: string;
}

/**
 * Check if a given object implements the GetDictionaryTypeDto interface.
 */
export function instanceOfGetDictionaryTypeDto(value: object): value is GetDictionaryTypeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetDictionaryTypeDtoFromJSON(json: any): GetDictionaryTypeDto {
    return GetDictionaryTypeDtoFromJSONTyped(json, false);
}

export function GetDictionaryTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDictionaryTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function GetDictionaryTypeDtoToJSON(value?: GetDictionaryTypeDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

